import { createSlice } from '@reduxjs/toolkit';

import { INTERVALS } from '../../components/Scheduling/constants/intervals';

const INITIAL_STATE = {
  scheduling: {
    intervals: [...INTERVALS],
  },
};

export const SchedulingSlice = createSlice({
  name: 'scheduling',
  initialState: INITIAL_STATE,
  reducers: {
    setIntervals: (state, { payload }) => {
      state.scheduling.intervals = payload;
    },
    resetSchedulingSlice: () => INITIAL_STATE,
  },
});

export const { setIntervals, resetSchedulingSlice } = SchedulingSlice.actions;

export default SchedulingSlice.reducer;

export const selectorIntervalsScheduling = state =>
  state.scheduling.scheduling.intervals;
